import { cn } from 'src/shared/utils/cn'

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  animationType?: 'pulse' | 'shimmer'
}

function ShimmerSkeleton({ className }: SkeletonProps) {
  return <Skeleton className={className} animationType="shimmer" />
}

function Skeleton({ className, animationType = 'pulse', ...props }: SkeletonProps) {
  switch (animationType) {
    case 'pulse':
      return <div className={cn('animate-pulse rounded-md bg-muted/20', className)} {...props} />
    case 'shimmer':
      return (
        <div
          className={cn(
            'relative overflow-hidden rounded bg-gray-200 after:absolute after:inset-0 after:-translate-x-full after:animate-shimmer after:bg-gradient-to-r after:from-transparent after:via-white/20 after:to-transparent',
            className,
          )}
        />
      )
  }
}

export { Skeleton, ShimmerSkeleton }
